import { render, staticRenderFns } from "./sharePlayer.vue?vue&type=template&id=271626b5&scoped=true"
import script from "./sharePlayer.vue?vue&type=script&lang=js"
export * from "./sharePlayer.vue?vue&type=script&lang=js"
import style0 from "./sharePlayer.vue?vue&type=style&index=0&id=271626b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271626b5",
  null
  
)

export default component.exports